module.exports = __webpack_public_path__ + "static/media/cardis-horizontal.e305d308.png";